var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDynamiser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(-140 -4226)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 61,
    cy: 61,
    r: 61,
    transform: "translate(140 4226)",
    fill: "rgba(30,194,138,0.13)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cloud-storage",
    transform: "translate(162.447 4247.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(0 50.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M3.857,312a3.848,3.848,0,0,0-1.286,7.478v14.381H5.143V319.478A3.848,3.848,0,0,0,3.857,312Zm0,5.143a1.286,1.286,0,1,1,1.286-1.286A1.287,1.287,0,0,1,3.857,317.143Z",
    transform: "translate(0 -312)",
    fill: "#58a596"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(15.43 56.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M99.857,352a3.848,3.848,0,0,0-1.286,7.478v15.666h2.572V359.478A3.848,3.848,0,0,0,99.857,352Zm0,5.143a1.286,1.286,0,1,1,1.286-1.286A1.287,1.287,0,0,1,99.857,357.143Z",
    transform: "translate(-96 -352)",
    fill: "#58a596"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(7.715 55.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M53.143,358.381V344H50.572v14.381a3.857,3.857,0,1,0,2.572,0Zm-1.286,4.907A1.286,1.286,0,1,1,53.143,362,1.287,1.287,0,0,1,51.857,363.287Z",
    transform: "translate(-48 -344)",
    fill: "#58a596"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(72.006 50.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M451.857,312a3.848,3.848,0,0,0-1.286,7.478v14.381h2.572V319.478A3.848,3.848,0,0,0,451.857,312Zm0,5.143a1.286,1.286,0,1,1,1.286-1.286A1.287,1.287,0,0,1,451.857,317.143Z",
    transform: "translate(-448 -312)",
    fill: "#58a596"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(56.576 56.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M355.857,352a3.848,3.848,0,0,0-1.286,7.478v15.666h2.572V359.478A3.848,3.848,0,0,0,355.857,352Zm0,5.143a1.286,1.286,0,1,1,1.286-1.286A1.287,1.287,0,0,1,355.857,357.143Z",
    transform: "translate(-352 -352)",
    fill: "#58a596"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(64.291 55.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M405.143,358.381V344h-2.572v14.381a3.858,3.858,0,1,0,2.572,0Zm-1.286,4.907A1.286,1.286,0,1,1,405.143,362,1.287,1.287,0,0,1,403.857,363.287Z",
    transform: "translate(-400 -344)",
    fill: "#58a596"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(3.857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M84.376,18.059A12.843,12.843,0,0,0,66.282,7.577a16.709,16.709,0,0,0-30.669,8.079,14.145,14.145,0,0,0,2.532,28.062h.342A21.86,21.86,0,0,0,54.86,61.089v4.488H49.716L60,79.293,70.29,65.577H65.146V61.089A21.86,21.86,0,0,0,81.52,43.718h1.628a12.859,12.859,0,0,0,1.228-25.659ZM46.728,53.833a19.278,19.278,0,0,1-5.956-12.687h7.694a25.782,25.782,0,0,0,2.47,9.714A15.459,15.459,0,0,0,46.728,53.833Zm7.854-26.287A29.6,29.6,0,0,1,58.717,22.2v6.041A18.657,18.657,0,0,1,54.582,27.546Zm4.135,3.267v7.761H51.065a23.369,23.369,0,0,1,2.269-8.733A20.829,20.829,0,0,0,58.717,30.813Zm-6.6-4.217a12.843,12.843,0,0,1-3.4-2.343,19.146,19.146,0,0,1,7.625-3.32A31.275,31.275,0,0,0,52.116,26.6Zm-1.2,2.266a25.946,25.946,0,0,0-2.425,9.713H40.781A19.21,19.21,0,0,1,46.735,25.9,15.389,15.389,0,0,0,50.919,28.862ZM48.7,55.495a13.206,13.206,0,0,1,3.429-2.358,31.228,31.228,0,0,0,2.729,3.935V58.45A19.144,19.144,0,0,1,48.7,55.495ZM62.575,45V68.149h2.572L60,75.006,54.86,68.149h2.572V45H54.86v7.671a24.108,24.108,0,0,1-3.82-11.529H68.966a24.1,24.1,0,0,1-3.82,11.529V45Zm5.31-18.417a31.387,31.387,0,0,0-4.223-5.656,19.151,19.151,0,0,1,7.622,3.319A12.969,12.969,0,0,1,67.885,26.587Zm5.388-.688a19.213,19.213,0,0,1,5.953,12.676H71.514a25.946,25.946,0,0,0-2.425-9.713A15.438,15.438,0,0,0,73.273,25.9Zm-7.851,1.643a18.589,18.589,0,0,1-4.133.7V22.2A29.646,29.646,0,0,1,65.421,27.542Zm1.25,2.3a23.345,23.345,0,0,1,2.269,8.733H61.289V30.815A20.949,20.949,0,0,0,66.671,29.843ZM65.148,58.448V57.071h0a31.175,31.175,0,0,0,2.73-3.935,13.238,13.238,0,0,1,3.429,2.358A19.154,19.154,0,0,1,65.148,58.448Zm8.13-4.615a15.461,15.461,0,0,0-4.208-2.972,25.831,25.831,0,0,0,2.47-9.716h7.694A19.278,19.278,0,0,1,73.278,53.833Zm9.87-12.687H81.805c.024-.427.057-.854.057-1.286a21.859,21.859,0,0,0-43.718,0c0,.432.032.859.057,1.286h-.057a11.572,11.572,0,0,1-1.155-23.087l1.155-.179V16.716A14.144,14.144,0,0,1,64.676,9.891l.634,1.148,1.135-.657a10.273,10.273,0,0,1,15.417,8.906v1.286h1.286a10.287,10.287,0,0,1,0,20.573Z",
    transform: "translate(-24 0)",
    fill: "#58a596"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(20.662 5.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M128.552,42.127l2.551.318a9.011,9.011,0,0,1,8.933-7.873V32A11.584,11.584,0,0,0,128.552,42.127Z",
    transform: "translate(-128.552 -32)",
    fill: "#58a596"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamiser);
export default __webpack_public_path__ + "static/media/dynamiser.a06d54d6ffecffd949fb69bd8bc5f46e.svg";
export { ForwardRef as ReactComponent };